import { gsap } from 'gsap';
import { lg } from '../common';
import { disableScroll, enableScroll } from '../lib/scroll';

function initMainMenu(topbar) {
  const hamburger = topbar.querySelector('.topbar__hamburger');
  hamburger.setAttribute('aria-expanded', 'false');

  const open = () => {
    topbar.classList.add('topbar--is-menu-open');
    hamburger.setAttribute('aria-expanded', 'true');
    disableScroll();
  };
  const close = () => {
    topbar.classList.remove('topbar--is-menu-open');
    hamburger.setAttribute('aria-expanded', 'false');
    enableScroll();
  };
  const toggle = () =>
    topbar.classList.contains('topbar--is-menu-open') ? close() : open();

  hamburger.addEventListener('click', toggle);

  gsap.matchMedia().add(`(min-width: ${lg}px)`, () => {
    close();
  });
}

export function initTopbar() {
  const topbar = document.querySelector('.topbar');
  if (!topbar) return;

  initMainMenu(topbar);

  const langSelect = document.querySelector('.topbar__lang-desktop');
  if (langSelect) {
    langSelect.addEventListener('change', function () {
      const dataHref = this.selectedOptions[0].dataset.href;
      window.open(dataHref, '_blank');
    });
  }
}
